import { Text } from '@medly-components/core';
import { CSSProperties, ReactNode } from 'react';
import { DrawerSectionContent, DrawerSectionWrapper } from './DrawerSection.styled';

export type DrawerSection = {
    header: string;
    children: ReactNode;
    style?: CSSProperties;
};

export const DrawerSection = ({ header, children, style = {} }: DrawerSection) => {
    return (
        <DrawerSectionWrapper style={style}>
            <Text textVariant="h3" dangerouslySetInnerHTML={{ __html: header }}></Text>
            <DrawerSectionContent>{children}</DrawerSectionContent>
        </DrawerSectionWrapper>
    );
};
